<template>
    <div>
        <div class="dashboard-profile-pic">
            <img v-bind:src="image" :alt="name" v-if="image">
            <img v-else src="/images/user_avatar.png">
            <label for="clogo-edit" class="edit-icon"><i class="fas fa-pencil-alt"></i></label>
        </div>
        <div class="pic-details">
            <input type="file" id="clogo-edit" class="file" @change="onPhotoUploaded">
        </div>
        <div class="pd-sec-box">
            <i class="fas fa-user-tie"></i> Name
            <p>{{name}}</p>
        </div>
        <div class="pd-sec-box">
            <i class="fas fa-university"></i> College
            <p v-html="college"></p>
        </div>
        <div class="pd-sec-box">
            <i class="fas fa-mobile-alt"></i> Phone
            <p>{{phone}}</p>
        </div>
        <div class="pd-sec-box">
            <i class="fas fa-envelope"></i> Email
            <p>{{email}}</p>
        </div>
        <div class="divider"></div>
        <div class="vertical-navi">
            <ul class="nav flex-column">
                <li class="nav-item" v-on:click="setActive('dashboard')">
                    <router-link to="/dashboard" class="nav-link" :class="{active: isActive('dashboard') || isActive('/')}">Dashboard</router-link>
                </li>
                <li class="nav-item" v-on:click="setActive('applied')" v-if="this.$store.getters.getPreferences['show_jobs']">
                    <router-link to="/dashboard/applied" class="nav-link" :class="{active: isActive('applied')}">Applied Jobs</router-link>
                </li>
                <li class="nav-item" v-on:click="setActive('applied-internships')" v-if="this.$store.getters.getPreferences['show_internships']">
                    <router-link to="/dashboard/applied-internships" class="nav-link" :class="{active: isActive('applied-internships')}">Applied Internships</router-link>
                </li>
                <li class="nav-item" v-on:click="setActive('applied-loan')" v-if="this.$store.getters.getUser['education_loan']">
                    <router-link to="/dashboard/applied-loan" class="nav-link" :class="{active: isActive('applied-loan')}">Applied Loan Applications</router-link>
                </li>
<!--                <li class="nav-item" v-on:click="setActive('quiz')">-->
<!--                    <router-link to="/dashboard/quiz" class="nav-link" :class="{active: isActive('quiz')}">Quizzes</router-link>-->
<!--                </li>-->
                <li class="nav-item" v-on:click="setActive('edit')">
                    <router-link to="/dashboard/edit" class="nav-link" :class="{active: isActive('edit')}">Edit Profile</router-link>
                </li>
<!--                <li class="nav-item" v-on:click="setActive('classes')" v-if="this.$store.getters.getPreferences['show_teachers']">-->
<!--                    <router-link to="/dashboard/scheduled-classes" class="nav-link" :class="{active: isActive('classes')}">Scheduled Classes</router-link>-->
<!--                </li>-->
                <li class="nav-item" v-on:click="setActive('resume')">
                    <router-link to="/dashboard/resume" class="nav-link" :class="{active: isActive('resume')}" >Resume</router-link>
                </li>
<!--                <li class="nav-item" v-on:click="setActive('notes')" v-if="this.$store.getters.getPreferences['show_teachers']">-->
<!--                    <router-link to="/dashboard/previous-notes" class="nav-link" :class="{active: isActive('notes')}">Previous Notes</router-link>-->
<!--                </li>-->
            </ul>
            <div v-if="loggedIn">
                <ul class="account-btns float-none hide-sm" v-on:click="logoutClicked">
                    <li class="float-none"><i class="fas fa-sign-out-alt"></i> Logout</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import toastr from "../../public/js/toastr";
    import {hideLoader, requestHeaders, showLoader} from "../_helpers/apiHelper";

    export default {
        data() {
            return {
                activeItem: window.location.pathname.split('/')[window.location.pathname.split('/').length-1],
                name: '',
                email: '',
                phone: '',
                college: '',
                image: '',
                uploadedPhoto: null,
            }
        },
        mounted() {
            var t = this;
            var url = this.$store.getters.getDomain;
            var user = this.$store.getters.getUser;
            this.name = user['first_name'] + " " + user['last_name'];
            this.college = user['college'];
            this.phone = user['phone'];
            this.email = user['email'];

            axios.post(`${url}api/v2/cand-profile/profile-picture`, '',{
                headers: requestHeaders()
            }).then(function (response) {
                t.image = response['data'];
            }).catch(function (error) {

            })
        },
        computed: {
            changeImage() {
                return this.$store.getters.getImage;
            },
            loggedIn: function () {
                return this.$store.getters.getAuthState;
            }
        },
        watch: {
            changeImage(value) {
                var t = this;
                t.image = value;
            },
        },
        methods: {
            isActive: function (menuItem) {
                return this.activeItem === menuItem
            },
            setActive: function (menuItem) {
                return this.activeItem = menuItem
            },
            logoutClicked() {
                this.$store.dispatch("setLoggedOut");
                toastr.success('Logging out soon', 'Logged Out');
                window.location.replace("/");
            },
            onPhotoUploaded(event) {
                var t = this;
                var url = this.$store.getters.getDomain;
                this.uploadedPhoto = event.target.files[0];
                const fd = new FormData();
                fd.append('profile_image', this.uploadedPhoto, this.uploadedPhoto.name);
                showLoader();
                axios.post(`${url}api/v2/cand-profile/upload-profile-picture`, fd, {
                    headers: requestHeaders(),
                })
                    .then(res => {
                        hideLoader()
                        if (res.status == 200) {
                            var image = res['data']['response']['image'];
                            t.$store.dispatch("setImage", image);
                            toastr.success('Picture Uploaded Successfully', 'Success');
                        } else {
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                    })

            },
        }
    }
</script>